import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "status-wrapper" }
const _hoisted_2 = { class: "status-bar" }

import { useStore } from "vuex";
import TimelineStep from "@/components/timeline/TimelineStep.vue";
import TimelineStepDescription from "@/components/timeline/TimelineStepDescription.vue";
import useApplicationStatus from "@/composables/application-status/useApplicationStatus";


export default /*@__PURE__*/_defineComponent({
  __name: 'SchoolCertification',
  emits: ["todoListClicked", "viewCertificationUpdates"],
  setup(__props, { emit: __emit }) {

useStore();

const emit = __emit;

const { useV2, timeline, currentstep, selectedStep, stepCount } = useApplicationStatus();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeline), (step) => {
        return (_openBlock(), _createBlock(TimelineStep, {
          key: step.id,
          status: step.status,
          step: step.step,
          title: step.title,
          maximumStep: _unref(stepCount),
          configuration: step,
          onTitleClicked: _cache[1] || (_cache[1] = ($event: any) => (currentstep.value = $event)),
          onTodoListClicked: _cache[2] || (_cache[2] = ($event: any) => (emit('todoListClicked')))
        }, _createSlots({ _: 2 }, [
          (_unref(useV2) && _unref(currentstep) === step.step)
            ? {
                name: "caption",
                fn: _withCtx(() => [
                  _createVNode(TimelineStepDescription, {
                    class: "mobile",
                    step: step.step,
                    status: _unref(selectedStep).status,
                    mobile: true,
                    onViewCertificationUpdates: _cache[0] || (_cache[0] = ($event: any) => (emit('viewCertificationUpdates')))
                  }, null, 8, ["step", "status"])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["status", "step", "title", "maximumStep", "configuration"]))
      }), 128))
    ]),
    (_unref(useV2))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "divider" }, null, -1)),
          _createVNode(TimelineStepDescription, {
            step: _unref(selectedStep).step,
            status: _unref(selectedStep).status,
            onViewCertificationUpdates: _cache[3] || (_cache[3] = ($event: any) => (emit('viewCertificationUpdates')))
          }, null, 8, ["step", "status"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})